import * as React from "react";
import { joinClasses } from "../../../../utils/Filters";
import { Div } from "../../03-base/Div";
import { Label } from "../../05-atoms/Label";
import { fieldValidationState } from "./Field.utils";
/**
 *
 * @param props
 */
export var FormGroup = function (props) {
    var clazzName = joinClasses(props.className || "", "scl-o-form__group", props.asSummary ? "scl-o-form__group--as-summary" : "");
    return (React.createElement(Div, { className: clazzName, transparent: true, theme: { paletteState: fieldValidationState(props) } },
        props.label &&
            React.createElement(Label, { className: props.asSummary ? "scl-a-label__field--as-summary" : "" },
                props.label,
                props.required ? React.createElement("span", { className: "scl-a-label__field--as-required" }, "*") : ""),
        props.children));
};
